import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PartnerState } from '../../models/partners-state.model';
import { PartnerDetails } from '../../models/partners.model';
import { Partner } from '../../models/partners.model';


export const selectPartnerState = createFeatureSelector<PartnerState>('partner');

export const selectAllPartners = createSelector(
  selectPartnerState,
  (state: PartnerState) => state ? Object.values(state.entities) : []
);

export const selectPagedPartners = createSelector(
  selectPartnerState,
  (state: PartnerState) => state.partners
);

export const selectTotalItems = createSelector(
  selectPartnerState,
  (state: PartnerState) => state.totalItems
);

export const selectTotalPages = createSelector(
  selectPartnerState,
  (state: PartnerState) => state.totalPages
);



export const selectSearchedPartners = createSelector(
  selectPartnerState,
  (state: PartnerState) => state.searchedPartners
);

export const selectSelectedPartner = createSelector(
  selectPartnerState,
  (state: PartnerState) => state && state.entities[state.selectedPartnerId]
);

export const selectPartnerById = createSelector(
  selectPartnerState,
  (state: PartnerState): Partner | null => {
    if (state && state.entities && state.selectedPartnerId) {
      const partner = state.entities[state.selectedPartnerId];
      if (partner && 'locations' in partner && 'main_address' in partner && 'main_contact_phone' in partner && 'unique_id' in partner) {
        return partner as unknown as Partner;

      }
    }
    return null;
  }
);

export const selectPartner = createSelector(
  selectPartnerState,
  (state: PartnerState) => state.selectPartner
);

export const selectIsLoading = createSelector(
  selectPartnerState,
  (state: PartnerState) => state.loading ? state.loading : false
);

export const selectError = createSelector(
  selectPartnerState,
  (state: PartnerState) => state.error
);

export const selectPartnerLocations = createSelector(
  selectPartnerState,
  (state: PartnerState) => state.locations
);

export const selectPartnerCategories = createSelector(
  selectPartnerState,
  (state: PartnerState) => state.categories
);

export const selectedPartner = createSelector(
  selectPartnerState,
  (state: PartnerState) => state.selectPartner
);





